import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { ExportSamplesResponse } from "./type";
import type { SamplesFilters } from "../list/type";
import { isEmpty } from "@utils/formatters";

export async function exportSamples(
  query?: SamplesFilters,
): Promise<ExportSamplesResponse> {
  const params = new URLSearchParams();

  if (query) {
    Object.entries(query).forEach(([key, value]) => {
      if (isEmpty(value)) return;

      params.append(key, String(value));
    });
  }

  let url = apiPaths.samples.export;
  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await apiClient.get<ExportSamplesResponse>(url);

  return response.data;
}
